import type { ClinicalSheetRowInterpretation } from '@starter/shared';

export function hasExplicitClinicalContent(row: ClinicalSheetRowInterpretation): boolean {
  if (row.procedureTextNormalized?.trim()) return true;
  if (row.caseDateNormalized) return true;
  if (row.specialtyNormalized?.trim()) return true;
  if (row.caseRole) return true;
  if (row.sourceOccupancyState === 'OCCUPIED') return true;
  if (row.sourceCrossedOutState === 'PRESENT') return true;
  if (row.studentCrossedOutResolution === 'PRESENT') return true;
  if (row.studentOccupancyResolution === 'OCCUPIED' || row.studentOccupancyResolution === 'UNCERTAIN') {
    return true;
  }
  return false;
}

export function rowHasMeaningfulContent(row: ClinicalSheetRowInterpretation): boolean {
  return hasExplicitClinicalContent(row);
}
